import { render, staticRenderFns } from "./PMDashboardValidationSelector.vue?vue&type=template&id=3b5d3646&scoped=true&"
import script from "./PMDashboardValidationSelector.vue?vue&type=script&lang=js&"
export * from "./PMDashboardValidationSelector.vue?vue&type=script&lang=js&"
import style0 from "./PMDashboardValidationSelector.vue?vue&type=style&index=0&id=3b5d3646&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5d3646",
  null
  
)

export default component.exports